import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ClientRoles } from 'src/app/components/services/auth/auth.models';
import { AuthenticationService } from 'src/app/components/services/auth/authentication.service';
import { NavService, Menu } from '../../service/nav.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent {

  public menuItems: Menu[] = [];
  public url: any;
  public fileurl: any;

  constructor(
    private router: Router,
    public navServices: NavService,
    private authService: AuthenticationService
  ) {
    const roles = this.authService.currentUserValue?.roles;
    const permissions = this.authService.currentUserValue?.permissions;
    const hasPermissions = permissions && Object.keys(permissions).length > 0;

    const setupNav = (source$: any) => {
      source$.subscribe((items: Menu[]) => {
        this.menuItems = items || [];
        this.router.events.subscribe((event: any) => {
          if (event instanceof NavigationEnd && this.menuItems?.length) {
            this.menuItems.forEach(item => {
              if (item.path === event.url) this.setNavActive(item);
              (item.children || []).forEach(sub => {
                if (sub.path === event.url) this.setNavActive(sub);
                (sub.children || []).forEach(s => { if (s.path === event.url) this.setNavActive(s); });
              });
            });
          }
        });
      });
    };

    // admin o superadmin: menú filtrado por permisos
    if (roles === 'admin' || roles === 'superadmin') {
      if (hasPermissions) this.navServices.refreshMenu(permissions);
      setupNav(this.navServices.items);
      return;
    }
    // Usuarios con permisos (perfiles) pero rol distinto: tratar como admin
    if (hasPermissions) {
      this.navServices.refreshMenu(permissions);
      setupNav(this.navServices.items);
      return;
    }
    if (roles === 'user' || roles === 'citizenhead') {
      setupNav(this.navServices.itemsUser);
      return;
    }
    if (roles === 'funcionario') {
      setupNav(this.navServices.itemsArea);
      return;
    }
    if (roles === 'supervisor') {
      setupNav(this.navServices.itemsSupervisor);
      return;
    }
    // Rol no reconocido: menú mínimo (solo Inicio)
    setupNav(this.navServices.items);
  }

  // Active Nave state
  setNavActive(item) {
    if (!this.menuItems?.length) return;
    this.menuItems.filter(menuItem => {
      if (menuItem != item)
        menuItem.active = false
      if (menuItem.children && menuItem.children.includes(item))
        menuItem.active = true
      if (menuItem.children) {
        menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true
            submenuItems.active = true
          }
        })
      }
    })
  }

  // Click Toggle menu
  toggletNavActive(item) {
    if (!item.active) {
      this.menuItems.forEach(a => {
        if (this.menuItems.includes(item))
          a.active = false
        if (!a.children) return false
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false
          }
        })
      });
    }
    item.active = !item.active
  }

  //Fileupload
  readUrl(event: any) {
    if (event.target.files.length === 0)
      return;
    //Image upload validation
    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    // Image upload
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.url = reader.result;
    }
  }

}
